// extracted by mini-css-extract-plugin
export default {"screen_container":"BlogScreen_screen_container__6Wd5f","blogs_container":"BlogScreen_blogs_container__0rG0U"};